import React from 'react'
import ConnectedApp from '@driftt/traffic-control'
import PublicHome from 'components/PublicHome'
import AppPage from 'components/AppPage'
import AppsPage from 'components/AppsPage'
import AuthorizePage from 'components/AuthorizePage'
import AuthHandler from 'components/AuthHandler'
import DriftWidget from 'components/DriftWidget'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { hasTokens } from 'services/tokenService'
import config from 'config'
import './style.css'

const NAV_ITEMS = {
  APPS: {
    label: 'Apps',
    path: '/apps',
    requiredScopes: ['member'],
    iconSRC: 'window-code',
  },
  COMMUNITY: {
    label: 'Community',
    path: 'https://community.drift.com/categories/developer',
    requiredScopes: ['member'],
    iconSRC: 'lightning-bolt',
  },
  DOCS: {
    label: 'Docs',
    path: 'https://devdocs.drift.com',
    requiredScopes: ['member'],
    iconSRC: 'question',
  }
}

const onIndexRouteRender = () => {
  return hasTokens()
    ? <Redirect exact from="/" to="/apps" />
    : <PublicHome />
}

const ProtectedRoutes = () => (
  <Switch>
    <Route path="/apps" render={() => <AppsPage />}/>
    <Route path="/app/:id" render={() => <AppPage />}/>
    <Route path="/authorize" render={() => <AuthorizePage />}/>
    <Redirect from="/logout" to="/"/>
  </Switch>
)

const AppLayout = () => (
  <Router>
    <AuthHandler>
      <Switch>
        <Route exact path="/" render={onIndexRouteRender} />
        <Route render={() => <ConnectedApp
          navItems={NAV_ITEMS}
          mobileRedirectEnabled={false}
          render={() => <ProtectedRoutes />}
          authClientId={config.AUTH_CLIENT_ID}
        />} />
      </Switch>
      <DriftWidget embedId={config.EMBED_ID} />
    </AuthHandler>
  </Router>
)

export default AppLayout
